import React from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { formatDurationQna } from "../helpers/format-duration";
import { likeQuestion } from "../services/questions";

function CardQna(props) {
  const { setOpenLogin, data, setAudioId, audioId, setTitleAudio, eventCode } =
    props;
  const { t } = useTranslation();

  const [isQuestionLiked, setIsQuestionLiked] = React.useState(false);

  const isAnswered =
    audioId !== null ||
    data?.articleId !== null ||
    (data?.answerMode !== null && data?.answerMode !== "")
      ? true
      : false;
  const token = localStorage.getItem("token");
  const typeformResponse =
    data?.dataSource === "question"
      ? data?.typeformResponse
      : JSON.parse(data?.typeformResponse);

  let title = "";
  if (data?.dataSource === "question") {
    if (data?.modifiedQuestion) {
      title = data?.modifiedQuestion;
    } else {
      title = typeformResponse.split("::")[0];
    }
  }

  if (data?.dataSource === "typeform") {
    if (data?.modifiedQuestion) {
      title = data?.modifiedQuestion;
    } else {
      if (typeformResponse?.form_response?.answers?.[1]?.text) {
        title = typeformResponse?.form_response?.answers?.[1]?.text;
      }
    }
  }

  let categories = "";
  if (data?.dataSource === "question") {
    const response = data?.typeformResponse.split("::");

    categories =
      response.length > 1
        ? response?.[1]?.split(",").join(", ") ??
          `Tentang ${response?.[1]?.join(", ")}`
        : "";
  } else {
    if (
      typeformResponse?.form_response?.answers?.[3]?.choices &&
      typeformResponse.form_response.answers[0].choice.label !== "Lainnya"
    ) {
      categories = `Dari ${
        typeformResponse.form_response.answers[0].choice.label
      } tentang ${" "}
      ${typeformResponse.form_response.answers[3].choices.labels.join(", ")}`;
    }
  }

  let speakers = data?.speaker?.split("::");
  if (
    (!data?.speaker || data?.speaker === "") &&
    (data?.additionalSpeaker || data?.additionalSpeaker !== "")
  ) {
    speakers = data?.additionalSpeaker?.split("::");
  }

  const totalLike = isQuestionLiked
    ? parseInt(data?.totalLike) + 1
    : data?.totalLike;

  return (
    <div className="card-qna">
      <div className="up">
        <h1
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (data?.articleId) {
              window.open(
                `/e/${eventCode}/read-article/${data?.articleId}`,
                true
              );
              return;
            }

            if (data?.answerMode) {
              props.history.push("/e/" + eventCode + "/qna/" + data?.theId);
              return;
            }

            setTitleAudio(title);
            setAudioId(data?.audioId);
            return;
          }}
        >
          {title}
        </h1>
        <h5>
          {audioId !== null && `${formatDurationQna(data?.duration / 1000)} `}
          {audioId === null &&
            `${t("seen-by")} ${data?.totalLoad} ${t("people")}`}
          {categories && categories.trim() !== "undefined" && (
            <span style={{ textTransform: "capitalize" }}> • {categories}</span>
          )}
        </h5>
      </div>
      <div className="down">
        {speakers && speakers[0] !== "" && (
          <div className="speakers">
            <img
              src={"https://fammi.ly/uploads/speakers/images/" + speakers[1]}
              alt="speakers"
            />
            <div style={{ width: "95%" }}>
              {speakers[0] && <h4>{speakers[0]}</h4>}
              {speakers[2] && (
                <h5
                  style={{
                    whiteSpace: "nowrap",
                    width: "95%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {speakers[2]}
                </h5>
              )}
            </div>
          </div>
        )}
        <div
          className="cta-sections"
          style={{ margin: (!speakers || speakers[0] === "") && 0 }}
        >
          <div
            style={{ display: data?.dataSource !== "question" ? "none" : "" }}
            className="actions"
            onClick={() => {
              if (!token) {
                return setOpenLogin(true);
              }

              if (data?.isAlreadyLike !== "0") {
                return;
              }

              likeQuestion(data?.theId, token);
              setIsQuestionLiked(true);
            }}
          >
            <button
              style={{
                background:
                  parseInt(totalLike) === 0 &&
                  data?.isAlreadyLike === "0" &&
                  !isQuestionLiked
                    ? "#F2F2F2"
                    : parseInt(totalLike) > 0 &&
                      data?.isAlreadyLike === "0" &&
                      !isQuestionLiked
                    ? "#F2F2F2"
                    : (parseInt(totalLike) > 0 &&
                        data?.isAlreadyLike !== "0") ||
                      isQuestionLiked
                    ? "#FFDFE3"
                    : "#F2F2F2",
              }}
            >
              <img
                src={
                  parseInt(totalLike) === 0 &&
                  data?.isAlreadyLike === "0" &&
                  !isQuestionLiked
                    ? "/assets/images/new-heart.svg"
                    : parseInt(totalLike) > 0 &&
                      data?.isAlreadyLike === "0" &&
                      !isQuestionLiked
                    ? "/assets/images/new-heart.svg"
                    : (parseInt(totalLike) > 0 &&
                        data?.isAlreadyLike !== "0") ||
                      isQuestionLiked
                    ? "/assets/images/new-on-heart.svg"
                    : "/assets/images/new-heart.svg"
                }
                alt="heart"
              />
            </button>
            <p>
              {parseInt(totalLike) === 0 && t("give-support")}
              {(data?.isAlreadyLike !== "0" ||
                isQuestionLiked ||
                parseInt(totalLike) > 0) &&
                `${totalLike} ${t("supports")}`}
            </p>
          </div>

          <div
            className="actions"
            onClick={() => {
              if (!token) {
                return setOpenLogin(true);
              }

              if (data?.articleId) {
                props.history.push(
                  "/e/" + eventCode + "/read-article/" + data?.articleId
                );
                return;
              }

              if (data?.audioId) {
                setTitleAudio(title);
                setAudioId(data?.audioId);
                return;
              }

              if (data?.answerMode) {
                props.history.push("/e/" + eventCode + "/qna/" + data?.theId);
                return;
              }
              return;
            }}
          >
            <button style={{ background: isAnswered && "#F5F0FF" }}>
              <img
                src={
                  audioId !== null &&
                  (data?.answerMode !== null || data?.answerMode !== "")
                    ? "/assets/images/new-play.svg"
                    : data?.articleId !== null ||
                      (data?.answerMode !== null && data?.answerMode !== "")
                    ? "/assets/images/eye-on.svg"
                    : "/assets/images/new-eye.svg"
                }
                alt="heart"
              />
            </button>
            <p
              style={{
                color: isAnswered && "#6C60E0",
                fontWeight: isAnswered && 500,
              }}
            >
              {audioId !== null && t("listen-answer")}

              {data?.articleId !== null && t("see-answer")}

              {data?.answerMode !== null &&
                data?.answerMode !== "" &&
                data?.answerMode !== "null" &&
                data?.answerMode === "thread" &&
                t("see-answer")}

              {data?.articleId === null &&
                audioId === null &&
                (data?.answerMode === "" ||
                  data?.answerMode === "null" ||
                  data?.answerMode === null) &&
                t("not-answered")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default withRouter(CardQna);
